import type { GivingContentObjectList } from 'models';
import { routes } from 'routes/routes';
import { Link } from 'ui';
import { GivingCardContent } from 'features/givings';
import { PinnedFeedCardLayout } from '../pinned-feed-card-layout';

type P = {
  item: GivingContentObjectList;
};

const PinnedGivingCard = ({ item }: P) => {
  const { giving } = item;

  return (
    <PinnedFeedCardLayout className="pinned-giving-card__layout">
      <Link className="pinned-giving-card__link" to={routes.giving.detail(giving.id)}>
        <GivingCardContent giving={giving} showZeroRaised titleEllipsis={{ rows: 2, tooltip: true }} />
      </Link>
    </PinnedFeedCardLayout>
  );
};

export default PinnedGivingCard;
